module.exports = __webpack_public_path__ + "static/img/kenia-os.6fa45e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/distribution-musical/img/kenia-os.jpg
// module id = Tsfh
// module chunks = 17